// Cena 3 — Quadro da equipe (áudio ~28s)
// O quadro fictício cobre o quadro real: colunas Aguardando / Administrador /
// Ana Lima. O cursor mira os CARDS reais renderizados ([data-demo='card-*'])
// e ARRASTA os atendimentos entre as colunas em sincronia com a animação.
const BOARD = "[data-tour='dash-board']";
const MARIA = "[data-demo='card-maria']";
const CARLOS = "[data-demo='card-carlos']";
const FULL = { position: "absolute", inset: 0 };

export default async function board(ctx) {
	await ctx.waitFor(BOARD, 4000);

	// mantém os números fictícios dos cards de estatística lá de cima
	ctx.mount("statOverlay", "[data-tour='dash-stat-open']", {
		label: "Em atendimento",
		value: 3,
		colorKey: "open",
		style: FULL,
	});
	ctx.mount("statOverlay", "[data-tour='dash-stat-pending']", {
		label: "Aguardando",
		value: 1,
		colorKey: "pending",
		style: FULL,
	});
	ctx.mount("statOverlay", "[data-tour='dash-stat-closed']", {
		label: "Finalizado",
		value: 15,
		colorKey: "closed",
		style: FULL,
	});

	// quadro fictício com Maria e Carlos aguardando
	const b = ctx.mount("teamBoard", BOARD, { phase: "intro", style: FULL });
	ctx.spotlight(BOARD);
	await ctx.wait(1200);

	// "cada atendente tem a sua coluna... clientes novos caem em Aguardando"
	await ctx.waitFor(MARIA, 4000);
	await ctx.cursorTo(MARIA, { duration: 900 });
	await ctx.wait(4600);

	// arrasta a Maria: Aguardando -> Administrador (você)
	await ctx.drag(MARIA, { sel: BOARD, ax: 0.5, ay: 0.42 }, {
		duration: 1150,
		onGrab: () => ctx.update(b, { phase: "dragMaria" }),
	});
	ctx.update(b, { phase: "afterMaria" });
	await ctx.wait(4200);

	// "para passar um cliente a outro atendente, é só arrastar" — Carlos
	await ctx.waitFor(CARLOS, 4000);
	await ctx.cursorTo(CARLOS, { duration: 750 });
	await ctx.wait(1400);

	// arrasta o Carlos: Aguardando -> Ana Lima
	await ctx.drag(CARLOS, { sel: BOARD, ax: 0.84, ay: 0.42 }, {
		duration: 1150,
		onGrab: () => ctx.update(b, { phase: "dragCarlos" }),
	});
	ctx.update(b, { phase: "done" });
	await ctx.wait(500);

	const t = ctx.mount("toast", BOARD, {
		icon: "🔀",
		text: "Transferido para a Ana na hora!",
	});
	await ctx.wait(3800);
	ctx.unmount(t);

	await ctx.wait(2200);
	ctx.spotlight(null);
}
